import { gql } from "@apollo/client";

export const isDriverVerificationPendingQuery = gql`
  query {
    is_driver_verification_pending
  }
`;
